import React from 'react';
import { motion } from 'framer-motion';

const ringVariants = {
  animate: {
    scale: [0.8, 2.5],
    opacity: [0.6, 0],
    transition: {
      duration: 1.6,
      repeat: Infinity,
      ease: 'easeOut',
      repeatDelay: 0.3,
    },
  },
};

const iconVariants = {
  animate: {
    scale: [1, 1.1, 1],
    filter: ['drop-shadow(0 0 4px #00f7ff)', 'drop-shadow(0 0 10px #00f7ff)', 'drop-shadow(0 0 4px #00f7ff)'],
    transition: {
      duration: 1.6,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  },
};

export default function LoadingPulse() {
  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1000,
      pointerEvents: 'none',
      width: 120,
      height: 120,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      {/* Rings */}
      <motion.div
        style={{
          position: 'absolute',
          width: 120,
          height: 120,
          borderRadius: '50%',
          border: '2.5px solid #00f7ff',
          boxSizing: 'border-box',
        }}
        variants={ringVariants}
        animate="animate"
      />
      <motion.div
        style={{
          position: 'absolute',
          width: 120,
          height: 120,
          borderRadius: '50%',
          border: '2.5px solid #00f7ff',
          boxSizing: 'border-box',
          animationDelay: '0.8s',
        }}
        variants={ringVariants}
        animate="animate"
      />

      {/* Your icon in center */}
      <motion.img
        src="/favicon.ico"
        alt="AR Loading Icon"
        style={{ width: 48, height: 48, position: 'relative', zIndex: 10 }}
        variants={iconVariants}
        animate="animate"
      />
    </div>
  );
}
